/**
 * Loads an external script and inserts it into the DOM.
 *
 * @param config - The script source, DOM id, and optional target node for the injected script tag.
 * @returns A promise that resolves once the script already exists or the injected script fires `load`.
 */
export const loadScript = (config) => {
    return new Promise(resolve => {
        var _a;
        const existingScript = document.getElementById(config.scriptId);
        if (existingScript) {
            resolve();
            return;
        }
        const script = document.createElement('script');
        script.src = config.src;
        script.id = config.scriptId;
        script.onload = () => {
            resolve();
        };
        const node = (_a = config.documentNode) !== null && _a !== void 0 ? _a : document.head;
        if (node) {
            node.appendChild(script);
        }
    });
};
